module.exports = __webpack_public_path__ + "img/cabinet_color_2.95fd3b75.svg";